
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/plan",
      function () {
        return require("private-next-pages/users/plan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/plan"])
      });
    }
  